import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const exportToPDF = ({ data, columns, fileName }) => {
  const doc = new jsPDF();

  const tableData = data.map((item) =>
    columns.map((col) =>
      typeof col.accessor === "function"
        ? col.accessor(item)
        : item[col.accessor]
    )
  );

  const headers = [columns.map((col) => col.label)];

  autoTable(doc, {
    head: headers,
    body: tableData,
  });

  doc.save(fileName || "data.pdf");
};
